import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

const AgBox = ({ children, sx, marginTop, paddingTop }:
  {children?: ReactNode; 
    sx?: SxProps<Theme> | undefined; 
    marginTop?: string; 
    paddingTop?:string }) => {
  return (
    <Box
      sx={sx ?? { border: '1px solid lightgrey', borderRadius: '2em', padding: '2em', marginTop: { marginTop }, paddingTop: { paddingTop } }}
    >{children}</Box>
  );
};

export default AgBox;